import React from 'react';
import { useParams } from 'react-router';

function Content() {
  const { title } = useParams<{ title: string }>();

  return title === 'skp-pembelajaran' ? (
    <div className="p-16">
      <h1 className="font-size-18" style={{ marginBottom: 36 }}>
        Tingkatkan SKP Pembelajaran dengan Mudah bersama Lifepack
      </h1>

      <p>SKP Pembelajaran (Ranah A) Dokter Turun? Jangan Khawatir!</p>
      <p>
        Saat ini, Lifepack berkolaborasi dengan Plataran Sehat
        (http://lms.kemkes.go.id ) untuk mengadakan pembelajaran sesuai minat
        Dokter dan tentunya semua SKP tetap dihitung sesuai dengan KMK no.
        HK.01.07/menkes/1561/2024.
      </p>
      <p>
        Untuk Ranah A, SKP maksimal yang bisa dihitung adalah 60% dari total
        kecukupan SKP masing-masing profesi.
      </p>
      <p className="mb-0">Sedangkan, sisa SKP bisa didapatkan dari:</p>
      <ol style={{ paddingInlineStart: '1.5rem', marginTop: 0 }}>
        <li>⁠35% Pelayanan</li>
        <li>5% Pengabdian</li>
      </ol>

      <p className="mb-0">
        Contoh perhitungan maksimal SKP dari Ranah A di SatuSehat:
      </p>
      <ol style={{ paddingInlineStart: '1.5rem', marginTop: 0 }}>
        <li>⁠Dokter/Dokter Spesialis : 150 dari 250 SKP</li>
        <li>Dokter Gigi/Apoteker/Psikolog : 60 dari 100 SKP</li>
        <li>⁠Perawat/Bidan/Profesi Nakes Lain : 30 dari 50 SKP</li>
      </ol>
      <p>
        Mau tetap update dan diskusi lebih lanjut bersama kami dan ahli
        profesional lainnya? <br />
        Yuk, gabung dengan grup WhatsApp khusus di link berikut:
      </p>
      <p>
        Link Grup Komunitas:{' '}
        <a
          href={process.env.REACT_APP_WA_COMMUNITY}
          className="font-weight-700 link-primary"
        >
          Klik Disini
        </a>
      </p>
      <p>
        Link Channel WhatsApp:{' '}
        <a
          href={process.env.REACT_APP_WA_CHANNEL}
          className="font-weight-700 link-primary"
        >
          Klik Disini
        </a>
      </p>
    </div>
  ) : null;
}

export default Content;
